const handleReviewSlider = (element) => {
  let $slider = element;

  return $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 10000,
    draggable: true,
    pauseOnHover: true,
  });
};

export default handleReviewSlider;

handleReviewSlider($(".review-carousel"));
